// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body[data-v-0a3dced8]{\n  margin:0;\n  padding:0\n}\n#map[data-v-0a3dced8]{\n  position:absolute;\n  top:0;\n  bottom:0;\n  width:100%\n}\n#marker[data-v-0a3dced8]{\n  cursor:pointer\n}\n.mapboxgl-popup[data-v-0a3dced8]{\n  max-width:200px\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
